import { render, staticRenderFns } from "./ResidualValues.vue?vue&type=template&id=54a85c40&scoped=true"
import script from "./ResidualValues.vue?vue&type=script&lang=js"
export * from "./ResidualValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a85c40",
  null
  
)

export default component.exports